import React from 'react'

export const File = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_925)'>
      <path
        d='M2.99999 9H8.99999C9.26521 9 9.51956 8.89464 9.7071 8.70711C9.89464 8.51957 9.99999 8.26522 9.99999 8V2H20.002C20.553 2 21 2.455 21 2.992V21.008C20.9997 21.2712 20.895 21.5235 20.7088 21.7095C20.5226 21.8955 20.2702 22 20.007 22H3.99299C3.86167 21.9991 3.73181 21.9723 3.61084 21.9212C3.48986 21.8701 3.38014 21.7957 3.28793 21.7022C3.19572 21.6087 3.12283 21.4979 3.07343 21.3762C3.02402 21.2545 2.99907 21.1243 2.99999 20.993V9ZM2.99999 7L7.99999 2.003V7H2.99999Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_925'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
